Template.bandAdmin.helpers({
  bands: () => {
    return Bands.find({});
  }
  // bandImage: (id) => {
  //   var band = Bands.findOne(id);
  //   var image =  Images.find(id);
  // }
  //
});



Template.bandAdmin.events({
  "click .sendMailToAllBands": function() {
    alert("send mail to all");
  },
  "click .sendMailToBand": function(e) {
    alert("send mail to " + this.name);
    Meteor.call("sendBandMail", this._id);
  }

});

